var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['section_comm', `section_${_vm.camelToSnake(_vm.id)}`, { active : _vm.isActive }],attrs:{"id":'section'+_vm.id.charAt(0).toUpperCase() + _vm.id.slice(1)}},[_c('div',{class:['inner_section', `inner_${_vm.camelToSnake(_vm.id)}`]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }